import ToggleImageCard from "../../../../pages/components/ToggleImageCard";
import desktopImage1 from "../../../../pages/img/desktop-main-guest01.png";
import mobileImage1 from "../../../../pages/img/mobile-main-guest01.png";
import * as React from 'react';
export default {
  ToggleImageCard,
  desktopImage1,
  mobileImage1,
  React
};